<template>
  <v-dialog transition="slide-x-transition" width="500px" persistent v-model="alertStore.status">
    <v-card>
      <!-- <v-app-bar dense>
        <v-btn @click.prevent="unsetAlert" icon>
          <v-icon> arrow_back </v-icon>
        </v-btn>
        <v-avatar size="36" color="red ml-1 mr-6">
          <v-icon class="fadeIn" color="white"> warning </v-icon>
        </v-avatar>
        <h3>Erro</h3>
      </v-app-bar> -->
      <v-card-title>
        Erro
      </v-card-title>
      <v-card-text>
        <v-timeline dense>
          <v-timeline-item :key="e" v-for="e in alertStore.errors" small color="red">
            <span class="text-uppercase">{{ e }}</span>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      
      <v-card-actions>
        <v-btn class="fonte" outlined block @click.prevent="unsetAlert">
          ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Alert",
  data() {
    return {};
  },
  computed: {
    alertStore() {
      return this.$store.getters.getAlert;
    },
  },
  methods: {
    ...mapActions(["unsetAlert"]),
  },
  created() {},
};
</script>